var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-320 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.707 -.707 .707 .707 121.442 -7.196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116 224c0-2.209-1.791-4-4-4-9.04 0-30.96 0-40 0-2.209 0-4 1.791-4 4v24c0 2.209 1.791 4 4 4h40c2.209 0 4-1.791 4-4 0-6.148 0-17.852 0-24z",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.707 -.707 .707 .707 121.442 -7.196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m68 228h48v8h-48z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 -128)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m116 224c0-2.209-1.791-4-4-4-9.04 0-30.96 0-40 0-2.209 0-4 1.791-4 4v24c0 2.209 1.791 4 4 4h40c2.209 0 4-1.791 4-4 0-6.148 0-17.852 0-24z",
    fill: "#ff6c5c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m116 224c0-2.209-1.791-4-4-4-9.04 0-30.96 0-40 0-2.209 0-4 1.791-4 4v24c0 2.209 1.791 4 4 4h40c2.209 0 4-1.791 4-4 0-6.148 0-17.852 0-24z",
    fill: "#ff6c5c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m116 224c0-2.209-1.791-4-4-4-9.04 0-30.96 0-40 0-2.209 0-4 1.791-4 4v24c0 2.209 1.791 4 4 4h40c2.209 0 4-1.791 4-4 0-6.148 0-17.852 0-24z",
    fill: "#ff6c5c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m68 228h48v8h-48z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m112 242c0-1.105-.895-2-2-2h-4c-1.105 0-2 .895-2 2v4c0 1.105.895 2 2 2h4c1.105 0 2-.895 2-2z",
    fill: "#ffce4b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m96 245.998c0-1.103-.895-1.998-1.998-1.998-4.519 0-15.481 0-20.002 0-.53 0-1.039.211-1.414.586s-.586.884-.586 1.414.211 1.039.586 1.414.884.586 1.414.586h20.002c1.103 0 1.998-.895 1.998-1.998 0-.001 0-.003 0-.004z",
    fill: "#ffce4b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/PG.45c5bf35d28f533dcaf1b5b8b94ddd1c.svg";
export { ForwardRef as ReactComponent };